export default "__VITE_ASSET__wyT_sqDg__"